/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StartUploadDto } from '../../models/start-upload-dto';
import { StartUploadResponseDto } from '../../models/start-upload-response-dto';

export interface MatchVideoControllerStartUpload$Params {
  uuid: string;
      body: StartUploadDto
}

export function matchVideoControllerStartUpload(http: HttpClient, rootUrl: string, params: MatchVideoControllerStartUpload$Params, context?: HttpContext): Observable<StrictHttpResponse<StartUploadResponseDto>> {
  const rb = new RequestBuilder(rootUrl, matchVideoControllerStartUpload.PATH, 'post');
  if (params) {
    rb.path('uuid', params.uuid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StartUploadResponseDto>;
    })
  );
}

matchVideoControllerStartUpload.PATH = '/match-videos/{uuid}/upload/start';
